<span class="badge badge-pedido-status badge-pedido-status-aprovado">
    {{status.nome}}
</span>